<template>
  <div class="components-container">
    <el-dialog :visible.sync="isShowModel" width="65%" center>
      <div class="row form-horizontal">
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label"> School Name </label>
          <div class="col-sm-4">
            <div>
              <el-input
                v-model="schoolFilterParams.schoolName"
                name="search"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label"> District </label>
          <div class="col-sm-4">
            <div>
              <el-select
                class="select-body"
                :disabled="!isFreeSelectDistrict"
                v-model="schoolFilterParams.districtCode"
                placeholder="Pleace select"
              >
                <el-option
                  v-for="item in districtList"
                  :key="item.districtCode"
                  :label="item.districtNameEn"
                  :value="item.districtCode"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label"> School Level </label>
          <div class="col-sm-4">
            <div>
              <el-select
                class="select-body"
                v-model="schoolFilterParams.schoolLevel"
                placeholder="Pleace select"
              >
                <el-option
                  v-for="item in schoolLevel"
                  :key="item.key"
                  :label="item.label"
                  :value="item.key"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="col-sm-2 textRight">
            <el-button type="primary" @click="getSchoolList">{{
              $t("message.Search")
            }}</el-button>
          </div>
        </div>
      </div>
      <div class="row table-responsive" style="padding-bottom: 60px">
        <el-table
          :header-row-style="{
            'background-color': '#EBEBEB',
            color: '#676a6c',
          }"
          :highlight-current-row='!isMultiple'
          :data="schoolList"
          style="width: 100%"
          ref="multipleTable"
          :fit="true"
          class="rowss"
          row-key="id"
          @current-change="handleSelectionChange"
          @selection-change="handleMultipleSelectionChange"
          
        >
          <el-table-column v-if="isMultiple" type="selection" width="55"></el-table-column>
          <el-table-column
            label="School Name"
            prop="schoolName"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
        </el-table>
        <el-col :span="24" class="el-table_footertoolbar">
          <el-pagination
            layout="total, prev, pager, next, jumper"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 50, 100, 200]"
            :page-size="schoolFilterParams.pageSize"
            :total="total"
            style="float: right"
          >
          </el-pagination>
        </el-col>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeModel">Cancel</el-button>
        <el-button type="primary" :disabled='isMultiple?!schoolCodeList.length:!schoolCode' @click="handleAdd">Add</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import config from "../../config";
export default {
  name: "schoolSelectModel",
  components: {},
  mixins: [config.globalMixin],
  data() {
    return {
      isShowModel: false,
      districtList: [],
      schoolFilterParams: {
        districtCode: "",
        schoolName: "",
        schoolLevel: "",
        pageSize: 5,
        pageIndex: 1,
      },
      schoolList: [],
      total: 0,
      schoolCode: null,
      schoolCodeList:[],
      isFreeSelectDistrict:false
    };
  },
  props: {
    isShowAddModel: {
      type: Boolean,
      default: false,
    },
    districtCode:{
      type: String,
      default: '',
    },
    isMultiple:{
      tyoe:Boolean,
      default:false
    }
  },
  watch: {
    isShowModel: {
      handler: function (e) {
        if (!e) this.$emit("close", e);
        else{
          if(this.districtCode=='JPC_HQ'){
            this.isFreeSelectDistrict =true
          }else{
            this.isFreeSelectDistrict =false
          }
        }
      },
    },
    isShowAddModel: {
      handler: function (e) {
        if (e) {
          this.isShowModel = e;
        }
      },
      immediate: true,
    },
    districtCode: {
      handler: function (e) {
        this.schoolFilterParams.districtCode = e
        this.getSchoolList();
      },
      immediate: true,
    },
    
  },
  computed: {
    schoolLevel() {
      return [
        { key: 1, label: "Primary School" },
        { key: 2, label: "Secondery school" },
      ];
    }
  },
  methods: {
    closeModel() {
      this.isFreeSelectDistrict =false
      this.schoolCodeList = []
      this.schoolCode = null
      this.$forceUpdate()
      this.isShowModel = false;
    },
    handleAdd() {
      this.$emit("add",this.isMultiple?this.schoolCodeList:this.schoolCode)
      this.closeModel();
    },
    async getDistrictList() {
      let obj = this.getAuthObj();
      obj.apiUrl = this.apiConfig.districtGetlist;
      let data = await this.$store.dispatch("apiEvent", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.$set(this, "districtList", data.data.result);
    },
    async getSchoolList() {
      let obj = this.getAuthObj();
      obj.apiUrl = "/school/list";
      const params = {
        ...obj,
        ...this.schoolFilterParams,
      };
      let data = await this.$store.dispatch("apiEvent", params);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.total = data.data.result.total;
      this.schoolList = data.data.result.schools;
    },
    handleCurrentChange(val) {
      this.schoolFilterParams.pageIndex = val;
      this.getSchoolList();
    },
    handleCurrentChange(val) {
      this.schoolFilterParams.pageIndex = val;
      this.getSchoolList();
    },
    handleSelectionChange(e) {
      if (!this.isMultiple) this.schoolCode = e;
    },
    handleMultipleSelectionChange(e){
      if (this.isMultiple) this.schoolCodeList = e  
    }
  },
  mounted(){
    this.getSchoolList();
  },
  created() {
    this.getDistrictList();
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-table__body tr.current-row > td.el-table__cell{
    background-color: #1ab394 !important;
    color:#ffffff
}
.components-container {
}
</style>
